<template>
  <div>
    <van-nav-bar
        left-arrow
        title="我的爱心"
        @click-left="$router.go(-1)"
        left-text="">
    </van-nav-bar>
    <div style="padding-top: 50px" class="wxYaoUser">
      <div class="balance_header" :style="{background:'url('+asdImgs+')  no-repeat'}">
      </div>
      <div class="balance_tips" style="  box-shadow: 0 2px 12px rgb(100 101 102 / 12%) !important;">
        <div style="">
          <div>
            <van-row>
              <van-col span="12">
                <div style="float: left;margin: 15px 0px 0px 20px;font-size: 13pt">我的爱心</div>
              </van-col>
              <van-col span="12">
                <div style="float: right;margin: 15px 20px 0px 20px;color: #595858;font-size: 10pt"
                     @click="goCashRecord">爱心记录 >
                </div>
              </van-col>
            </van-row>
          </div>
          <van-divider/>
          <van-row class="user-links">
            <van-col span="12">
              <div style="font-size: 19pt;font-weight: bold">{{ totalBalance }}<span style="font-size: 11pt"></span>
              </div>
              <div class="topCount">累计爱心</div>
            </van-col>
            <van-col span="12">
              <div style="font-size: 19pt;font-weight: bold">{{ lastBalance }}<span style="font-size: 11pt"></span>
              </div>
              <div class="topCount">可用爱心</div>
            </van-col>
          </van-row>
        </div>
      </div>
      <div>
        <van-row>
          <van-col span="8">
            <div style="float: left;margin: 25px 0px -10px 15px;font-size: 13pt">我的邀请</div>
          </van-col>
          <van-col span="16">
            <div style="text-align: right;margin: 25px 20px -10px 15px;font-size: 10pt;color: rgb(89, 88, 88)">团队总共{{totalTeamCount}}人</div>
          </van-col>
        </van-row>
      </div>
      <van-divider/>
      <div style="margin-top: 15px">
        <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad"
        >
          <div
              v-for="item in list"
              :key="item.id">
            <div class="kyzCard1111">
              <div>
                <van-row>
                  <van-col span="4">
                    <van-image
                        round
                        width="40px"
                        height="40px"
                        :src="$getFileAccessHttpUrl(item.avatar)"
                    />
                  </van-col>
                  <van-col span="20">
                    <div style="margin-top: 0px">
                      {{ item.nickName }}
                    </div>
                    <div style="margin-top: 0px">
                      {{ item.createTime }}
                    </div>
                  </van-col>
                </van-row>
                <van-divider/>
              </div>
            </div>
          </div>
        </van-list>
      </div>
    </div>
    <van-image-preview v-model="showShare" :images="images" :closeable="true">
    </van-image-preview>
  </div>
</template>

<script>
import {
  NavBar, Divider,
  Button, Field, Tab, Tabs,
  List, Card
} from 'vant'
import {postAction} from '@/api/manage'

export default {
  components: {
    [Button.name]: Button, [Divider.name]: Divider,
    [List.name]: List, [Tab.name]: Tab, [Tabs.name]: Tabs,
    [Field.name]: Field, [NavBar.name]: NavBar, [Card.name]: Card,
  },

  data() {
    return {
      asdImgs: '/img/paysuccess-bg.png',
      list: [],
      loading: false,
      finished: false,
      pageNumber: 1,
      balanceLast: 0,
      kyz: this,
      totalBalance: 0,
      lastBalance: 0,
      totalTeamCount:0,
      showShare: false,
      images: [
        '',
      ],
    }
  },
  mounted() {
    this.getBalance()
  },
  methods: {
    onLoad() {
      this.loadData()
    },
    getBalance() {
      const that = this
      //发送 post 请求
      postAction('/web/api/user/loveAmount', {}).then(function (response) {
        console.log(response.result)
        that.totalBalance = response.result.totalBalance
        that.lastBalance = response.result.lastBalance
      }).finally(() => {
      })
      postAction('/web/api/user/getMyTeamCount', {}).then(function (response) {
        console.log(response.result)
        that.totalTeamCount = response.result.data
      }).finally(() => {
      })

    },
    loadData() {
      const that = this
      //发送 post 请求
      this.$nextTick(() => {
        postAction('/web/api/user/getMyTeamList', {
          'pageNo': that.pageNumber,
        }).then(function (response) {
          console.log(response.result)
          // 异步更新数据
          for (let i = 0; i < 10; i++) {
            if (response.result.data.records[i]) {
              that.list.push(response.result.data.records[i])
            }
          }
          that.pageNumber = that.pageNumber + 1
          // 加载状态结束
          that.loading = false
          // 数据全部加载完成
          console.log(response.result.data.total )
          console.log(that.list.length )
          if (that.list.length >= response.result.data.total) {

            that.finished = true
          }
        })
      })
    },
    goCashRecord() {
      this.$router.push({name: 'account/myLoveRecord'})
    },
    showShareChange() {
      const that = this
      postAction('/web/api/user/makeHaiBao', {}).then(function (response) {
        that.images[0] = that.$getFileAccessHttpUrl(response.result.destPath) + '?date=' + new Date().getTime()
        that.showShare = true
      })
    },
  }
}
</script>

<style lang="less" scoped>
.van-card__bottom {
  padding-bottom: 20px;
}

.van-card__desc {
  margin-top: 6px;
}

.van-card__title {
  font-size: 11pt;
}

.wxYaoUser .van-card__price {
  font-size: 13pt !important;
}

.wxYaoUser .van-card__price-integer {
  font-size: 13pt !important;
}

.van-nav-bar {
  position: fixed;
  width: 100%;
}

.balance_header {
  background-size: 100%;
  height: 90px
}

.balance_header .balance_amount {
  text-align: center;
  padding-top: 10px;
  font-size: 22pt;
  color: white
}

.balance_header .balance_zhan {
  text-align: center;
  padding-top: 0px;
  font-size: 11pt;
  color: white
}

.balance_tips {
  background-color: white;
  margin: -60px 20px 0px 20px;
  height: 130px;
  border-radius: 15px;
  text-align: center;
  line-height: 20px;
}

.kyzCard1111 .van-button__text {
  color: #07c160
}

.kyzCard1111 {
  background-color: white;
  color: #454545;
  font-size: 10pt;
  padding-top: 10px;
  padding-left: 10px;
  padding-bottom: 0px;
}

.kyzCard1111 .kyzCardAmount {
  color: red;
  font-size: 21px;
  padding-top: 6px
}

.topCount {
  font-size: 10pt;
  margin-top: 5px;
  color: gray;
}
</style>
